import * as _ from 'lodash-es';
import { Delta } from 'quill/core';

const isPostContentEmpty = (initialContent: Delta | null) => {
  const { ops } = new Delta(initialContent || []);
  return (
    ops.length === 1 &&
    _.isEmpty(_.omit(ops[0]?.attributes, ['author'])) &&
    (ops[0]?.insert === '\n' || ops[0]?.insert === '\n\n')
  );
};

export default isPostContentEmpty;
